import { render, staticRenderFns } from "./SpecialismPage.vue?vue&type=template&id=0612527c&"
import script from "./SpecialismPage.vue?vue&type=script&lang=js&"
export * from "./SpecialismPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports